import type { TLShape } from "@tldraw/tlschema";
import { Rectangle2d } from "../geometry2d";
import { ShapeUtil, HTMLContainer } from "../shape-util";

/** Stands in for shape types this engine cannot draw yet, keeping their place on the board. */
export class PlaceholderShapeUtil extends ShapeUtil<TLShape> {
  static override type = "__placeholder__";
  getDefaultProps() {
    return {} as TLShape["props"];
  }
  private size(shape: TLShape) {
    const props = shape.props as { w?: number; h?: number };
    return {
      w: Math.max(24, Number(props.w) || 120),
      h: Math.max(24, Number(props.h) || 80),
    };
  }
  getGeometry(shape: TLShape) {
    const { w, h } = this.size(shape);
    return new Rectangle2d({ width: w, height: h, isFilled: true });
  }
  override canResize() {
    return false;
  }
  override hideRotateHandle() {
    return true;
  }
  component(shape: TLShape) {
    const { w, h } = this.size(shape);
    return (
      <HTMLContainer
        className="canvas-shape-error"
        style={{ width: w, height: h, boxSizing: "border-box" }}
      >
        {shape.type} — not yet available in this editor
      </HTMLContainer>
    );
  }
}
